export default { sha: '5f0ae4630830a202f1685494b0a42cc991990964', buildNumber: 'undefined' }
